import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { facadeFactory, provideDefaultConfigFactory } from '@spartacus/core';
import { CART_BASE_FEATURE } from '@spartacus/cart/base/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CART_WISH_LIST_FEATURE = 'cartWishList';
const CART_WISH_LIST_CORE_FEATURE = 'cartWishListCore';
const ADD_TO_WISHLIST_FEATURE = 'addToWishList';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let WishListFacade = /*#__PURE__*/(() => {
  class WishListFacade {
    static {
      this.ɵfac = function WishListFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WishListFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WishListFacade,
        factory: () => (() => facadeFactory({
          facade: WishListFacade,
          feature: CART_WISH_LIST_CORE_FEATURE,
          methods: ['createWishList', 'getWishList', 'loadWishList', 'addEntry', 'removeEntry', 'getWishListLoading'],
          async: true
        }))(),
        providedIn: 'root'
      });
    }
  }
  return WishListFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultCartWishListComponentsConfig() {
  const config = {
    featureModules: {
      [CART_WISH_LIST_FEATURE]: {
        cmsComponents: ['WishListComponent'],
        dependencies: [CART_BASE_FEATURE]
      },
      [ADD_TO_WISHLIST_FEATURE]: {
        cmsComponents: ['AddToWishListComponent']
      },
      // by default core is bundled together with components
      [CART_WISH_LIST_CORE_FEATURE]: CART_WISH_LIST_FEATURE
    }
  };
  return config;
}
let WishListRootModule = /*#__PURE__*/(() => {
  class WishListRootModule {
    static {
      this.ɵfac = function WishListRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WishListRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: WishListRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultCartWishListComponentsConfig)]
      });
    }
  }
  return WishListRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ADD_TO_WISHLIST_FEATURE, CART_WISH_LIST_CORE_FEATURE, CART_WISH_LIST_FEATURE, WishListFacade, WishListRootModule, defaultCartWishListComponentsConfig };
